/* eslint-disable @typescript-eslint/no-explicit-any */
import Alliance from './Alliance';
import Arieblok from './Arieblok';
import Arvesta from './Arvesta';
import AveveAgrarisch from './AveveAgrarisch';
import Avevebiochem from './Avevebiochem';
import AveveMedia from './AveveMedia';
import Belcrop from './Belcrop';
import Cofabel from './Cofabel';
import Equifirst from './Equifirst';
import Equilannoo from './Equilannoo';
import Eurotuin from './Eurotuin';
import Hafner from './Hafner';
import Hermoo from './Hermoo';
import Hobbyfirst from './Hobbyfirst';
import Hortiplan from './Hortiplan';
import Kasperfaunafood from './Kasperfaunafood';
import Lannoo from './Lannoo';
import NaturalGranen from './NaturalGranen';
import Nuverta from './Nuverta';
import Osmo from './Osmo';
import Palital from './Palital';
import Peka from './Peka';
import PentaTrading from './PentaTrading';
import Pomagro from './Pomagro';
import Proxani from './Proxani';
import Sabe from './Sabe';
import Sanac from './Sanac';
import Scoriethom from './Scoriethom';
import Servagri from './Servagri';
import Spoormans from './Spoormans';
import Vaesken from './Vaesken';
import Walagri from './Walagri';
import WimLybaert from './WimLybaert';

const themes: { [key: string]: any } = {
  Alliance,
  Arieblok,
  Arvesta,
  AveveAgrarisch,
  AveveMedia,
  Avevebiochem,
  Belcrop,
  Cofabel,
  Equifirst,
  Equilannoo,
  Eurotuin,
  Hafner,
  Hermoo,
  Hobbyfirst,
  Hortiplan,
  Kasperfaunafood,
  Lannoo,
  NaturalGranen,
  Nuverta,
  Osmo,
  Palital,
  Peka,
  PentaTrading,
  Pomagro,
  Proxani,
  Sabe,
  Sanac,
  Scoriethom,
  Servagri,
  Spoormans,
  Vaesken,
  Walagri,
  WimLybaert,
};

export default themes;
